import { commonMessages } from '@/__scripts/common.messages';
import { T } from '@/components/i18n/message.i18n.component';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select/select.component';
import React from 'react';

export interface SelectInputOption {
  value: string;
  label: React.ReactNode;
  testId: string;
}

interface Props {
  onChange: (value: string) => void;
  value?: string;
  placeholder?: string;
  options: SelectInputOption[];
}

export const SelectInput = ({ onChange: handleSelectChange, value, placeholder, options, ...props }: Props) => {
  return (
    <Select value={value} data-testid="select-input" onValueChange={handleSelectChange}>
      <SelectTrigger data-testid="select-input-trigger" className="w-[180px] mr-4" {...props}>
        <SelectValue data-testid="select-input-value" placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} data-testid={`select-input-option-${option.value}`} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
        {options.length === 0 && (
          <SelectItem data-testid="select-input" disabled value="disabled">
            <T {...commonMessages.selectComponentNoOptions} />
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
};
